function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as e } from "react/jsx-runtime";
import { useTheme as l } from "../../hooks.js";
import { useIsInverseVariant as h } from "../../theme-variant-context.js";
import { vars as c } from "../../skins/skin-contract.css-mistica.js";
const a = (_param)=>{
    var { color: i , size: o = 24  } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const n = h(), t = i !== null && i !== void 0 ? i : n ? c.colors.inverse : c.colors.neutralHigh, { skinName: s  } = l();
    return s.match(/^o2/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: o,
        height: o,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ e("path", {
            fill: t,
            d: "M21.5 21.63V22h-19v-.37c0-3.441 3.032-6.347 7.122-7.172-2.217-.981-3.78-3.29-3.78-5.978C5.842 4.906 8.604 2 12 2c3.396 0 6.158 2.906 6.158 6.48 0 2.688-1.559 4.997-3.78 5.978 4.095.83 7.122 3.73 7.122 7.172z"
        })
    })) : /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: o,
        height: o,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ e("path", {
            fill: t,
            d: "M8.391 10.796c.84.81 2.053 1.219 3.61 1.219 1.558 0 2.774-.409 3.614-1.219.877-.84 1.322-2.086 1.322-3.705 0-1.62-.442-2.869-1.319-3.712-.843-.812-2.059-1.224-3.616-1.224-1.558 0-2.77.412-3.61 1.224-.872.843-1.315 2.093-1.315 3.712 0 1.619.443 2.865 1.314 3.705zM3.81 21.846h16.386c.308 0 .56-.251.56-.56v-1.638c0-1.569-.49-2.905-1.42-3.871-1.008-1.05-2.51-1.605-4.336-1.605H8.991c-1.827 0-3.323.557-4.33 1.608-.925.963-1.413 2.3-1.413 3.868v1.639c0 .308.252.56.56.56z"
        })
    }));
}, p = a;
export { p as default };
